// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__6IL1F","type":"styles_type__1WIyN","choices":"styles_choices__32kQq"};